import { render, staticRenderFns } from "./RTETitleIcon.vue?vue&type=template&id=3f23e822&scoped=true"
import script from "./RTETitleIcon.vue?vue&type=script&lang=js"
export * from "./RTETitleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f23e822",
  null
  
)

export default component.exports